export const CMS_NAVBAR = [
  { label: "Permissions", application: "auth", link: "/cms/permission" },
  // {label:'Exam', application:'exam',link:'/cms/exam'},
  { label: "Webinar", application: "webinar", link: "/cms/webinar" },
  { label: "Newsletter", application: "", link: "/cms/newsletter" },
  { label: "Product", application: "", link: "/cms/products" },
  {
    label: "Article Webinar SPG Mapping",
    application: "spgentitymapping",
    link: "/cms/article-webinar-mapping",
  },
  {
    label: "Coaching",
    application: "",
    link: "/cms/coaching",
    application: "cnextcoachingmaster",
  },
  {
    label: "Country",
    application: "",
    link: "/cms/country",
    application: "countrydata",
  },
  {
    label: "DomainBlock",
    application: "",
    link: "/cms/domain",
    application: "user",
  },
  {
    label: "User Contact Push",
    application: "logentry",
    link: "/cms/user-contact-push",
    // application: "user",
  },
  { label: "Manage Ranking", application: "", link: "/cms/manage-ranking" },
  // { label: "Colleges", application: "", link: "/cms/colleges/manage-ranking" }
  // {label:'Institute Data', application:'',link:'/cms/'},
  // {label:'Manage product-Mapping', application:'',link:'/cms/'},
  // {label:'Articles/News', application:'',link:'/cms/'},
  // {label:'Analytics', application:'',link:'/cms/'},
  // {label:'SEO', application:'',link:'/cms/'},
  // {label:'Admission Budy', application:'',link:'/cms/'},
  // {label:'School Data', application:'',link:'/cms/'},
  { label: "Degree Grouping", application: "", link: "/cms/degree-grouping" },
  { label: "Registration", application: "registration", link: "/cms/register" },
  { label: "Hiring", application: "", link: "/cms/hiring" },
  { label: "Video", application: "", link: "/cms/video" },
  { label: "Website Settings", application: "base", link: "/cms/static-pages" },
  { label: "Tools", application: "college_predictor", link: "/cms/tools" },
  { label: "Author Profile", application: "", link: "/cms/author" },
  { label: "Content", application: "", link: "/cms/content" },
  { label: "Poll Management", application: "", link: "/cms/polls" },
  { label: "WA URL Mapping", application: "users", link: "/cms/whatsapp-mapping" },
];

export const STEPPER_LIST = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "Basic Information",
    route: "basic-details",
  },
  {
    title: "Dates & Application",
    route: "dates-application",
  },
  {
    title: "Exam Syllabuss",
    route: "exam-syllabus",
  },
  {
    title: "Exam Insights",
    route: "exam-insights",
  },
  {
    title: "Counselling Details",
    route: "counselling-details",
  },
  {
    title: "Other Details",
    route: "other-details",
  },
  {
    title: "FAQs",
    route: "exam-faqs",
  },
];

export const STEPPER_LIST_COLLEGE = [
  {
    title: "Overview",
    route: "overview",
    count: 0,
  },
  {
    title: "Basic Detail",
    route: "basic-details",
    count: 1,
  },
  {
    title: "Gallery",
    route: "gallery",
    count: 2,
  },
  {
    title: "Approvals",
    route: "approvals",
    count: 3,
  },
  {
    title: "Admission Details",
    route: "admission-details",
    count: 4,
  },
  {
    title: "Notable Alumni",
    route: "notable-alumni",
    count: 5,
  },
  {
    title: "FAQs",
    route: "faqs",
    count: 6,
  },
];

export const STEPPER_LIST_PROGRAMMES = [
  {
    title: "Basic Details",
    route: "basic-details",
  },
  {
    title: "AICTE Placements",
    route: "aicte-placements",
  },
  {
    title: "Course Overview",
    route: "overview",
  },
  {
    title: "Course Content",
    route: "content",
  },
  {
    title: "Dates and Gallery",
    route: "dates-and-gallery",
  },
];

export const PERMISSIONS_SUB_NAV = [
  {
    title: "Add Permission",
    step: 0,
    route: "",
  },
  {
    title: "Add Groups",
    step: 1,
    route: "/group",
  },
  // {
  //     title: 'Manage Group Permissions',
  //     step :2,
  //     route:'group-permission'
  // },
  {
    title: "Users Management",
    step: 3,
    route: "/userlist",
  },
  {
    title: "Block Users",
    step: 4,
    route: "/blockusers",
  },
  // {
  //   title: "Staff Register",
  //   step: 5,
  //   route: "/staff-register",
  // },
  {
    title: "Account Deletion",
    step: 4,
    route: "/user-account-deletion",
  },
];

//Table Css
export const CUSTOM_STYLE_PERMISSION_DATA_TABLE = {
  rows: {
    style: {
      "&:nth-of-type(odd)": {
        backgroundColor: "#f1f1f1",
      },
    },
  },
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "bold",
    },
  },
  cells: {
    style: {},
  },
  customFirstColumnCellStyle: {
    whiteSpace: "nowrap"
  },
};

// latest Table Css
export const CUSTOM_STYLE_DATA_TABLE = {
  rows: {
    style: {
        backgroundColor: "#fff",
    },
  },
  headCells: {
    style: {
      fontSize: "15px",
      color:'#8d99aa',
      // fontWeight: "bold",
    },
  },
  cells: {
    style: {},
  },
  customFirstColumnCellStyle: {
    whiteSpace: "nowrap"
  },
};

export const WEBINAR_TYPE = [
  { label: "Non Premium", value: 1 },
  { label: "Premium", value: 2 },
];

export const WEBINAR_STATUS = [
  { label: "Ongoing", value: 1 }, //live
  { label: "Scheduled", value: 2 }, // upcoming
  { label: "Ended", value: 3 }, // past
  { label: "Inactive", value: 4 },
];

export const WEBINAR_ACCESS_TYPES = [
  { label: "Open To Alls", value: 1 },
  { label: "Registered Users", value: 2 },
  { label: "Paid Users", value: 3 },
];

export const WEBINAR_URL_ACCESS_TYPES = [
  { label: "Open To All", value: 1 },
  { label: "Registered Users", value: 2 },
  { label: "Premium Paid", value: 3 },
  { label: "Premium One Free", value: 4 },
];

export const WEBINAR_URL_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const WEBINAR_URL_CHANNEL = [
  {
    label: "Youtube",
    value: 1,
    check: "youtube",
    regex: "^(http(?:s?)://(?:www.)?youtu(?:be.com/))",
  },
  { label: "Youtube Embed", value: 3, check: "", regex: "^(http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/embed\/))" },
  {
    label: "Zoom",
    value: 2,
    check: "zoom",
    regex: "^((?:https?:)?//)?((?:www|m).)?((?:zoom.(us|in)))",
  },
];

export const NEWSLETTER_STATUS = [
  { label: "In Draft", value: 2 },
  { label: "Sent", value: 1 },
];

export const NEWSLETTER_ARTICLE_TYPE = [
  { label: "Free SEO", value: null },
  { label: "Premium SEO", value: 0 },
  { label: "Premium", value: 1 },
  { label: "Premium Paid", value: 2 },
  // { label: "News", value: "news" },
];

export const PRODUCTS_PLAN_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const MANAGE_PLAN_ACCESS_TYPE = [
  { label: "Allow All", value: "1" },
  { label: "No Change", value: "2" },
  { label: "Block All", value: "3" },
];

export const PLAN_VALIDITY_TYPE = [
  { label: "Fixed Form Date of Purchase", value: 1 },
  { label: "Time Period", value: 2 },
];

export const PLAN_VALIDITY_YEAR = [
  { label: "2020", value: "1" },
  { label: "2021", value: "2" },
  { label: "2022", value: "3" },
  { label: "2023", value: "4" },
  { label: "2024", value: "5" },
  { label: "2025", value: "6" },
  { label: "2026", value: "7" },
  { label: "2027", value: "8" },
  { label: "2028", value: "9" },
  { label: "2029", value: "10" },
];

export const PLAN_ACCESS_TYPE = [
  { label: "Registered", value: 1 },
  { label: "Paid", value: 2 },
  { label: "Unlocked from other SPG", value: 3},
];

export const FEATURES_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const FEATURE_GROUPS_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const CMS_PRODUCT_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const LANDING_PAGE_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const LANDING_PAGE_BANNER_STATUS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 2 },
];

export const USER_PRODUCT_ACCESS_TYPE = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
];

export const PAYMENT_STATUS = [
  { label: "Payment Initiated", value: 1 },
  { label: "Payment Completed", value: 2 },
  { label: "Payment Failed", value: 3 },
  { label: "Payment In Process", value: 4 },
];

export const MANAGE_ACCESS_STATUS = [
  { label: "Active", value: 1 },
  { label: "No Change", value: 2 },
  { label: "Inactive", value: 3 },
];

export const FEATURE_KEYWORD = [
  { label: "MHT CET", value: "1" },
  { label: "Class 12", value: "2" },
  { label: "JEE Main", value: "3" },
  { label: "Class 11", value: "4" },
  { label: "MHT Counselling 2021", value: "5" },
  { label: "MHT CET", value: "6" },
  { label: "MHT CET", value: "7" },
  { label: "MHT CET", value: "8" },
  { label: "MHT Counselling 2021", value: "9" },
  { label: "MHT Counselling 2021", value: "10" },
  { label: "MHT Counselling 2021", value: "11" },
  { label: "MHT Counselling 2021", value: "12" },
  { label: "MHT Counselling 2021", value: "13" },
];

export const MANAGE_DIGREE_DIPLOMA = [
  {
    title: "Basic Details",
    route: "certificate",
  },
  {
    title: "AICTE Placements",
    route: "aicte-placements",
  },
];

export const MANAGE_CERTIFICATE = [
  {
    title: "Course Overview",
    route: "",
  },
  {
    title: "Course Content",
    route: "content",
  },
  {
    title: "Dates and Gallery",
    route: "dates-and-gallery",
  },
];

export const LANDING_PAGE_TYPES = [
  { label: "General", value: 1 },
  { label: "Marketing", value: 2 },
];

// export const PLAN_FEATURE_CHECK = [
//   { label: false, value: "0" },
//   { label: true, value: "1" },
// ];

export const newsletterHTMLTags = `<html>
  <head>
  <custom name="opencounter" type="tracking"> <meta charset="utf-8"></custom>
  <link href="https://fonts.googleapis.com" rel="preconnect" />
  <link crossorigin="" href="https://fonts.gstatic.com" rel="preconnect" />
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&amp;display=swap" rel="stylesheet" /> 
  </head>
  <body>`;

export const MANAGE_PLAN_FRONT_END = [
  { label: "Show Title", value: "1" },
  { label: "Show Description", value: "2" },
  { label: "Show Both", value: "3" },
];

export const STEPPER_LIST_COACHING = [
  {
    title: "Overview",
    route: "overview",
  },
  {
    title: "Coaching Courses",
    route: "coaching-courses",
  },
  {
    title: "Coaching  Institute",
    route: "coaching-institute",
  },
  {
    title: "Toppers Details",
    route: "toppers-details",
  },
  {
    title: "Media",
    route: "media",
  },
];

export const SOCIAL_URL = [
  { label: "Twitter", value: "1" },
  { label: "Youtube", value: "2" },
  { label: "Facebook", value: "3" },
  { label: "Wikipedia", value: "4" },
];

export const COUNTRY_STATUS = [
  { label: "Published", value: 1 },
  { label: "Unpublished", value: 0 },
];
export const LEVEL_STATUS = [
  { label: "UG", value: "1" },
  { label: "PG", value: "2" },
  { label: "PHD", value: "3" },
];

export const COST_OF_LIVING_TYPE = [
  {
    value: 1,
    label: "House Rent",
  },
  {
    value: 2,
    label: "Food",
  },
  {
    value: 3,
    label: "Clothes & Shoes",
  },
  {
    value: 4,
    label: "Books & Stationery",
  },
  {
    value: 5,
    label: "Travel",
  },
  {
    value: 6,
    label: "Others",
  },
];

export const STEPPER_LIST_COUNTRY = [
  {
    title: "Overview",
    route: "overview",
  },
  {
    title: "Basic Detail",
    route: "basic-detail",
  },
  {
    title: "Content Detail",
    route: "content-detail",
  },
  {
    title: "Gallery",
    route: "gallery",
  },
  {
    title: "Faqs",
    route: "faqs",
  },
];

// Manage Ranking Constants

export const TABLE_DATA = [
  {
    id: 1,
    college_name: "Hydrabad University Cambridge",
    authoruty: "THE",
    ranking_type: "Overall",
    stream: "Overall",
    year: "2023",
    rank: "2",
    score: "95.5",
    rank_band: [
      { rank: "2", score: "95.2" },

    ],
  },
  {
    id: 2,
    college_name: "Hydrabad University Cambridge",
    authoruty: "THE",
    ranking_type: "Overall",
    stream: "Overall",
    year: "2023",
    rank_band: [
      { rank: "2", score: "95.2" },

    ],
  }
]

export const SEARCH_BY_COUNTRY = [
  { id: 1, label: "Hyrabad University", },
  { id: 2, label: "Hyrabad University1", },
]

export const SEARCH_BY_COLLEGE = [
  { id: 1, label: "Sample College", },
  { id: 2, label: "Sample College1", },
]

export const SEARCH_BY_AUTHORITY = [
  { id: 1, label: "The", },
]

export const SEARCH_BY_RANKING_TYPE = [
  { id: 1, label: "Overall", },
]

export const SEARCH_BY_STREAM = [
  { id: 1, label: "Sample Stream", },
  { id: 2, label: "Sample Stream1", },
]

export const SEARCH_BY_YEAR = [
  { id: 1, label: "2021", },
  { id: 2, label: "2023", },
]
// degreeGrouping constant started 

export const ALL_GROUP_LIST = [
  {
    "id": 1,
    "added_on": "2023-09-20T11:31:03Z",
    "updated_on": "2023-09-20T11:31:03Z",
    "name": "first",
    "status": 0
  },
  {
    "id": 2,
    "added_on": "2023-09-20T11:31:37Z",
    "updated_on": "2023-09-20T11:31:37Z",
    "name": "2nd",
    "status": 1
  },
  {
    "id": 3,
    "added_on": "2023-09-20T11:32:13Z",
    "updated_on": "2023-09-20T11:32:13Z",
    "name": "3rd",
    "status": 1
  },
]
export const ALL_DEGREE_LIST = [
  {
    "id": 1,
    "degree_id": 1,
    "degree_name": "Diploma",
    "degree_full_name": null,
    "degree_level": "Diploma",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:07Z",
    "updated": "2023-09-20T11:31:07Z"
  },
  {
    "id": 2,
    "degree_id": 11,
    "degree_name": "Dual Degree",
    "degree_full_name": null,
    "degree_level": "UG",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:08Z",
    "updated": "2023-09-20T11:31:08Z"
  }
]

export const GROUP_LIST = [
  {
    "id": 1,
    "group_name": "first",
    "group_status": 0
  },
  {
    "id": 2,
    "group_name": "2nd",
    "group_status": 1
  },
  {
    "id": 3,
    "group_name": "3rd",
    "group_status": 1
  }
]

export const DEGREE_LIST = [
  {
    "id": 1,
    "degree_name": "Diploma",
    "degree_full_name": null
  },
  {
    "id": 11,
    "degree_name": "Dual Degree",
    "degree_full_name": null
  },
  {
    "id": 111,
    "degree_name": "M.H.M.",
    "degree_full_name": "Master of Hotel Management"
  },
  {
    "id": 2,
    "degree_name": "B.E /B.Tech",
    "degree_full_name": "Bachelor of Engineering, Bachelor of Technology"
  },
  {
    "id": 22,
    "degree_name": "P.G.D",
    "degree_full_name": "Post Graduate Diploma"
  },
]

export const GROUP_STATUS = [
  {
    "id": 0,
    "value": "Unpublished"
  },
  {
    "id": 1,
    "value": "Published"
  }
]

export const DEGREE_STATUS = [
  {
    "id": 1,
    "value": "Published"
  },
  {
    "id": 0,
    "value": "Unpublished"
  }
]

export const GROUPING_CONTEXT_LIST = [
  {
    "id": 1,
    "degree_id": 1,
    "degree_name": "Diploma",
    "degree_full_name": null,
    "degree_level": "Diploma",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:07Z",
    "updated": "2023-09-20T11:31:07Z"
  },
  {
    "id": 2,
    "degree_id": 11,
    "degree_name": "Dual Degree",
    "degree_full_name": null,
    "degree_level": "UG",
    "degree_status": "published",
    "group_id": 1,
    "group_name": "first",
    "group_status": 0,
    "created": "2023-09-20T11:31:08Z",
    "updated": "2023-09-20T11:31:08Z"
  }
]

// degreeGrouping constant ended 

// Manage Messagin

export const REGISTER_SUB_NAV = [
  {
    title: "Dgree Grouping",
    step: 0,
    route: "",
  },
  {
    title: "Manage Messaging",
    step: 1,
    route: "/messaging",
  },
]
export const MANAGE_MESSEGINGDATA = {
  "form_type": [
    { id: 1, type: "Registration" },
    { id: 2, type: "Embedded Form" },
    { id: 3, type: "Add Buddy" }
  ],
  "entity_type": [
    { id: 1, type: "Article" },
    { id: 2, type: "Ebook" },
    { id: 3, type: "Exam" }
  ],
  "cta": [
    { id: 1, type: "Question_Answer" },
    { id: 2, type: "Question_Answer_Later" },
    { id: 3, type: "Question_Report" },
    { id: 4, type: "Question_Report1" },
    { id: 5, type: "Question_Report2" },

  ],
  "domain": [
    { name: "www.careers360.com" },
    { name: "studyabroad.careers360.com" },
    { name: "news.careers360.com" },
  ],
  "url_meta_pattern": [
    { label: "ebook/<ebook_id>" },
    { label: "article/<article_id>" },
    { label: "college/<college_id>" }
  ],
  "url_Type": [
    { id: 1, value: "Start With" },
    { id: 2, value: "End With" },
    { id: 3, value: "Contains" },
  ],
  "table_data": [
    {
      id: 1,
      entity_type_name: "sample entity 1",
      cta_name: "sample CTA 1",
      sub_type: "sample subType 1",
      domain_name: "sample Domain 1",
      url: " sample url 1",
      url_meta_pattern: "sample url_meta_pattern1"
    },
    {
      id: 2,
      entity_type_name: "sample entity 2",
      cta_name: "sample CTA 2",
      sub_type: "sample subType 2",
      domain_name: "sample Domain 2",
      url: " sample url 2",
      url_meta_pattern: "sample url_meta_pattern2"
    }, {
      id: 3,
      entity_type_name: "sample entity 3",
      cta_name: "sample CTA 3",
      sub_type: "sample subType 3",
      domain_name: "sample Domain 3",
      url: " sample url 3",
      url_meta_pattern: "sample url_meta_pattern 3"
    }
  ]
}

export const JOB_LOCATION_TYPES = [
  { label: "On Site", value: "1" },
  { label: "Remote", value: "2" },
  { label: "Hybrid", value: "3" },
];

export const JOB_TYPE_LIST = [
  { label: "Full Time", value: "1" },
  { label: "Part Time", value: "2" },
  { label: "Contract", value: "3" },
  { label: "Internship", value: "4" },
];

export const JOB_STATUS = [
  { label: "Active", value: "1" },
  { label: "Closed", value: "0" },
];
export const MAPPED_ENTITY_TYPE = [
  {
    "id": 1,
    "name": "College Predictor"
  },
  {
    "id": 2,
    "name": "Campaign"
  },
  {
    "id": 3,
    "name": "Learn"
  }
]

export const OFFERING_TYPE = [
  {
    "id": 1,
    "name": "Single"
  },
  {
    "id": 2,
    "name": "Multiple"
  },
]

export const LEVEL_TYPE = [
  {
    "id": 1,
    "name": "Preferred Level"
  },
  {
    "id": 2,
    "name": "Current Level"
  },
  {
    "id": 0,
    "name": "All"
  },
]
export const AUTHOR_STATUS = [
  { label: "Published", value: 1 },
  { label: "Unpublished", value: 0 },
];

export const VIDEO_STATUS = [
  { label: "Published", value: 1 },
  { label: "Unpublished", value: 0 },
];

export const VIDEO_TYPE = [
  { label: "General", value: 1 },
  { label: "Shorts", value: 2 },
];
export const AUTHOR_ENTITY_TYPE = [
  { label: "Article", value: 1, entity_type: "articles" },
  { label: "News", value: 2, entity_type: "news_domain" },
];
export const PAGEAVAILABILITY= [
  {
    page_type: "Articles",
    value: 1,
    show_on_page: true,
  },
  {
    page_type: "Colleges",
    value: 2,
    show_on_page: true,
  },
  {
    page_type: "Exams",
    value: 3,
    show_on_page: true,
  },
  {
    page_type: "News",
    value: 4,
    show_on_page: true,
  },
  {
    page_type: "e-Books",
    value: 5,
    show_on_page: true,
  },
  {
    page_type: "Courses",
    value: 6,
    show_on_page: true,
  },
  {
    page_type: "Career Pages",
    value: 7,
    show_on_page: true,
  },
  {
    page_type: "App",
    value: 8,
    show_on_page: true,
  },
];

export const ALLOW_ACCESS = [
  {id:1,value:'Anonymous'},
  {id:2,value:'Registered'},
]


export const DEVICE_TYPE = [
  {id: 1, value: "Web"},
  {id: 2, value: "Mobile"},
  {id: 3, value: "App"},
]

export const REASON_DROPDOWN = [
  {id: 1, value: "Spam"},
  {id: 2, value: "Irrelavent Comment"},
  {id: 3, value: "Other"},
]
